import { render, staticRenderFns } from "./EditFormItem.vue?vue&type=template&id=21f32575&scoped=true&"
import script from "./EditFormItem.vue?vue&type=script&lang=js&"
export * from "./EditFormItem.vue?vue&type=script&lang=js&"
import style0 from "./EditFormItem.vue?vue&type=style&index=0&id=21f32575&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f32575",
  null
  
)

export default component.exports